import { i18n } from "../i18n.js";
import router from "../router";

export function localizedPath(routeKey) {
  if (!routeKey || typeof routeKey !== "string") {
    return "/";
  }

  const currentLocale = i18n.global.locale?.value || i18n.global.locale || "de";

  // Retrieve registered routes from the Vue Router instance
  const availableRoutes = router.getRoutes();

  // Find the route by its key name (case insensitive)
  const matchedRoute = availableRoutes.find(
    (route) => route.name?.toLowerCase() === routeKey.toLowerCase()
  );

  if (matchedRoute && matchedRoute.path) {
    // Replace locale placeholder dynamically in the URL
    let localizedPath = matchedRoute.path.replace(
      /:locale\((.*?)\)/,
      currentLocale
    );

    // Check if translation key exists before accessing it
    if (!i18n.global.te(`navbar.routes.${routeKey}`)) {
      return localizedPath; // Fallback to the original route segment
    }

    // Retrieve the translated route value
    const translatedRoute = i18n.global.t(`navbar.routes.${routeKey}`);

    // ✅ Use a full-word regex replacement to avoid partial matches
    localizedPath = localizedPath.replace(/[^/]+$/, translatedRoute);

    // Perform replacement using translation value
    // localizedPath = localizedPath.replace(routeKey, translatedRoute);

    return localizedPath;
  }

  return "/";
}
